/**
 * Variant media filter
 * ------------------------------------------------------------------------------
 * Shows only the gallery media assigned to the selected variant via the
 * variant metafield custom.variant_images. Media without any assignment
 * are shown for every variant. The variant's own featured image is always
 * part of its set.
 *
 * Markup (rendered by sections/main-product.liquid):
 *   .product-detail__images.has-variant-media[data-initial-variant-id]
 *     .product-detail__image[data-variant-ids="123 456"]   (slick slides)
 *   .product-detail__thumbnails.has-variant-media
 *     [data-product-media-thumbnail][data-variant-ids="123 456"]
 *
 * Depends on jQuery, Slick and theme.js (Boost). Must be loaded after theme.js.
 */
(function ($) {
  if (!$) {
    return;
  }

  var SECTION = '[data-section-type="product"]';
  var CONTAINER = ".product-detail__images.has-variant-media";
  var THUMBNAILS = ".product-detail__thumbnails.has-variant-media";
  var SLIDE = ".product-detail__image";
  var THUMBNAIL = "[data-product-media-thumbnail]";
  var FILTERED_CLASS = "is-filtered";

  /**
   * Whether an element (slide or thumbnail) belongs to the given variant.
   * Elements without data-variant-ids are shared media and always match.
   */
  function mediaMatches(el, variantId, featuredMediaId) {
    var ids = (el.getAttribute("data-variant-ids") || "").trim();
    if (!ids) {
      return true;
    }
    if (featuredMediaId && getMediaId(el) === String(featuredMediaId)) {
      return true;
    }
    return (" " + ids + " ").indexOf(" " + variantId + " ") !== -1;
  }

  /**
   * Media ID of a slide (nested [data-media-id]) or a thumbnail.
   */
  function getMediaId(el) {
    var mediaEl = el.hasAttribute("data-media-id") ? el : el.querySelector("[data-media-id]");
    return mediaEl ? String(mediaEl.getAttribute("data-media-id")) : "";
  }

  /**
   * Slick does not renumber slides after slickFilter, and theme.js reads the
   * index via jQuery .data("slick-index"), which caches the first value.
   * Re-sync both the attribute and the jQuery data cache with the DOM order.
   */
  function syncSlickIndexes($container) {
    $container.find(".slick-slide:not(.slick-cloned)").each(function (index) {
      this.setAttribute("data-slick-index", index);
      $(this).data("slick-index", index);
    });
  }

  /**
   * Look up the featured media ID of a variant from the section's product JSON.
   */
  function getFeaturedMediaId($section, variantId) {
    var json = $section.find("[data-product-json]").html();
    if (!json) {
      return null;
    }
    try {
      var product = JSON.parse(json);
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          return variants[i].featured_media ? variants[i].featured_media.id : null;
        }
      }
    } catch (e) {
      // ignore malformed JSON, fall back to metafield assignment only
    }
    return null;
  }

  /**
   * Apply the filter for a variant to the slideshow and the thumbnails.
   */
  function applyFilter($section, variantId, featuredMediaId) {
    var $container = $section.find(CONTAINER);
    if (!$container.length || !variantId) {
      return;
    }

    var matcher = function (el) {
      return mediaMatches(el, variantId, featuredMediaId);
    };

    if ($container.hasClass("slick-initialized")) {
      // remember the currently shown media so we can stay on it if it is still visible
      var currentMediaId = getMediaId($container.find(".slick-current")[0] || $container[0]);

      $container.slick("slickUnfilter");
      $container.slick("slickFilter", function () {
        return matcher(this);
      });
      syncSlickIndexes($container);

      var $current = $container.find(".slick-slide:not(.slick-cloned)").filter(function () {
        return getMediaId(this) === currentMediaId;
      });
      $container.slick("slickGoTo", $current.length ? $current.data("slick-index") : 0, true);
    } else {
      $container.children(SLIDE).each(function () {
        this.hidden = !matcher(this);
      });
    }

    $section.find(THUMBNAIL).each(function () {
      this.hidden = !matcher(this);
    });

    $container.addClass(FILTERED_CLASS);
    $section.find(THUMBNAILS).addClass(FILTERED_CLASS);
  }

  /**
   * Initial filter for the variant selected on page load (respects ?variant=).
   * Runs once slick is ready, or immediately when there is no slideshow.
   */
  function initSection(section) {
    var $section = $(section);
    var $container = $section.find(CONTAINER);
    if (!$container.length || $container.data("variantMediaFilterReady")) {
      return;
    }
    $container.data("variantMediaFilterReady", true);

    var variantId = $container.attr("data-initial-variant-id");
    var run = function () {
      applyFilter($section, variantId, getFeaturedMediaId($section, variantId));
    };

    if ($container.hasClass("slick-initialized")) {
      run();
    } else {
      // theme.js initialises the slideshow after this script has run (deferred sections)
      $container.one("init", run);
      // fallback when the slideshow is never created (e.g. single media, column layout)
      setTimeout(function () {
        if (!$container.hasClass(FILTERED_CLASS)) {
          run();
        }
      }, 1000);
    }
  }

  $(function () {
    $(SECTION).each(function () {
      initSection(this);
    });

    // variantChange is triggered by slate.Variants on the section container
    // before variantImageChange, so the theme's slickGoTo sees the filtered slides
    $(document).on("variantChange.variantMediaFilter", SECTION, function (evt) {
      var variant = evt.variant;
      if (!variant) {
        return;
      }
      applyFilter($(this), variant.id, variant.featured_media ? variant.featured_media.id : null);
    });

    // theme editor
    $(document).on("shopify:section:load", function (evt) {
      var section = evt.target.querySelector(SECTION);
      if (section) {
        initSection(section);
      }
    });
  });
})(window.jQuery);
